module.exports = __webpack_public_path__ + "img/1534817956.ea935e24.jpg";